import { usePageTitle } from "context/PageTitleContext";
import TeachersAndCoaches from "components/BookaMeeting/TeachersAndCoaches";
import Safeguarding from "components/BookaMeeting/Safeguarding";
import useGetStudentStaff from "hooks/useGetStudentStaff";

import styles from "./BookaMeeting.module.css";

import BrittanyHollandAvatar from "assets/images/BrittanyHollandHeadshot.jpg";
import CarrieMcGillicuddyAvatar from "assets/images/CarrieMcGillicuddyHeadshot.jpg";
import AdamDelphAvatar from "assets/images/AdamDelphHeadshot.jpg";
import PascaleFittsAvatar from "assets/images/PascaleFittsHeadshot.jpg";

const BookaMeeting = () => {
    usePageTitle("Book a Meeting");

    const { studentStaff, error, isLoading } = useGetStudentStaff();

    const safeguardingTeam = [
        {
            name: "Brittany Holland",
            role: "Head of School",
            email: "brittany.holland@gouspa.org",
            avatar: BrittanyHollandAvatar,
        },
        {
            name: "Carrie McGillicuddy",
            role: "Head of Student Support",
            email: "carrie.mcgillicuddy@gouspa.org",
            avatar: CarrieMcGillicuddyAvatar,
        },
        {
            name: "Adam Delph",
            role: "Head Learning Coach",
            email: "adam.delph@gouspa.org",
            avatar: AdamDelphAvatar,
        },
        {
            name: "Pascale Fitts",
            role: "Senior Learning Specialist",
            email: "pascale.fitts@gouspa.org",
            avatar: PascaleFittsAvatar,
        },
    ];

    return (
        <div className={styles.bookaMeeting}>
            <TeachersAndCoaches
                teachers={studentStaff}
                error={error}
                isLoading={isLoading}
            />
            <Safeguarding safeguardingTeam={safeguardingTeam} />
        </div>
    );
};

export default BookaMeeting;
